module.exports = __webpack_public_path__ + "media/images/admin/icons/trending-down-9044a5caa30decdb7c16560a05dce8be.svg";